module.exports = __webpack_public_path__ + "static/media/memorial_bw.ca946710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/memorial_bw.jpg
// module id = 422
// module chunks = 0